import React, { useEffect, useState } from "react";
import axios from "axios";

export default function ManageServicesPage() {
  const [tab, setTab] = useState("hero");
  const [loading, setLoading] = useState(false);
  const [pageData, setPageData] = useState({
    hero: null,
    intro: null,
    final_cta: null,
    services: [],
    why_choose: [],
    process: [],
    testimonials: [],
  });

  const [form, setForm] = useState({
    id: null,
    section_type: "",
    title: "",
    subtitle: "",
    description: "",
    icon: "",
    image: null,
  });

  const fetchData = async () => {
    setLoading(true);
    const res = await axios.get("http://localhost:8000/api/services-page");
    setPageData(res.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const resetForm = (sectionType, item = null) => {
    if (item) {
      setForm({
        id: item.id,
        section_type: sectionType,
        title: item.title || "",
        subtitle: item.subtitle || "",
        description: item.description || "",
        icon: item.icon || "",
        image: null,
      });
    } else {
      setForm({
        id: null,
        section_type: sectionType,
        title: "",
        subtitle: "",
        description: "",
        icon: "",
        image: null,
      });
    }
  };

  const handleSave = async () => {
    const fd = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null) fd.append(key, value);
    });
  const token = localStorage.getItem("auth_token");
    await axios.post("http://localhost:8000/api/services-page/save", fd, {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
    });

    await fetchData();
    alert("Saved!");
    resetForm(tab);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    await axios.delete(`/api/services-page/${id}`);
    await fetchData();
  };

  const renderListSection = (sectionType, list) => (
    <div>
      <div className="flex justify-end mb-3">
        <button
          onClick={() => resetForm(sectionType)}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          ➕ Add New
        </button>
      </div>

      {list.length === 0 && <p>No items yet.</p>}
      <div className="space-y-3">
        {list.map((item) => (
          <div
            key={item.id}
            className="p-4 border rounded flex justify-between items-center"
          >
            <div>
              <strong>{item.title}</strong>
              {item.subtitle && <div className="text-sm">{item.subtitle}</div>}
              {item.description && (
                <div className="text-sm text-gray-600">{item.description}</div>
              )}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => resetForm(sectionType, item)}
                className="px-3 py-1 bg-yellow-500 text-white rounded"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(item.id)}
                className="px-3 py-1 bg-red-500 text-white rounded"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {form.section_type === sectionType && renderForm()}
    </div>
  );

  const renderForm = () => (
    <div className="mt-6 p-4 border rounded">
      <h3 className="text-xl font-bold mb-4">
        {form.id ? "Edit" : "Add"} {form.section_type.replace("_", " ")}
      </h3>

      <label className="block font-semibold mb-1">Title</label>
      <input
        className="w-full border p-2 mb-3"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      {["hero", "final_cta", "testimonial"].includes(form.section_type) && (
        <>
          <label className="block font-semibold mb-1">Subtitle</label>
          <input
            className="w-full border p-2 mb-3"
            value={form.subtitle}
            onChange={(e) => setForm({ ...form, subtitle: e.target.value })}
          />
        </>
      )}

      {!["hero", "intro", "final_cta"].includes(form.section_type) && (
        <>
          <label className="block font-semibold mb-1">Description</label>
          <textarea
            className="w-full border p-2 mb-3"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </>
      )}

      {["service", "process", "why_choose"].includes(form.section_type) && (
        <>
          <label className="block font-semibold mb-1">Icon (optional)</label>
          <input
            className="w-full border p-2 mb-3"
            value={form.icon}
            onChange={(e) => setForm({ ...form, icon: e.target.value })}
          />
        </>
      )}

      {["hero", "service", "final_cta"].includes(form.section_type) && (
        <>
          <label className="block font-semibold mb-1">Image</label>
          <input
            type="file"
            className="w-full border p-2 mb-3"
            onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
          />
        </>
      )}

      <div className="flex justify-end gap-2">
        <button
          onClick={() => resetForm(form.section_type)}
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-green-600 text-white rounded"
        >
          Save
        </button>
      </div>
    </div>
  );

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Manage Services Page</h1>

      {/* TABS */}
      <div className="flex gap-3 mb-6">
        {[
          "hero",
          "intro",
          "services",
          "why_choose",
          "process",
          "testimonials",
          "final_cta",
        ].map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`px-4 py-2 rounded ${
              tab === t ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            {t.replace("_", " ").toUpperCase()}
          </button>
        ))}
      </div>

      {/* CONTENT PER TAB */}
      {tab === "hero" && (
        <>
          {pageData.hero && (
            <div className="mb-4 p-4 border rounded">
              <h3>{pageData.hero.title}</h3>
              <p>{pageData.hero.subtitle}</p>
              {pageData.hero.image && (
                <img
                  src={pageData.hero.image}
                  className="mt-2 w-64 rounded"
                  alt="hero"
                />
              )}
            </div>
          )}
          <button
            onClick={() => resetForm("hero", pageData.hero || null)}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {pageData.hero ? "Edit Hero" : "Add Hero"}
          </button>
          {form.section_type === "hero" && renderForm()}
        </>
      )}

      {tab === "intro" && (
        <>
          {pageData.intro && (
            <div className="mb-4 p-4 border rounded">
              <h3>{pageData.intro.title}</h3>
              <p>{pageData.intro.description}</p>
            </div>
          )}
          <button
            onClick={() => resetForm("intro", pageData.intro || null)}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {pageData.intro ? "Edit Intro" : "Add Intro"}
          </button>
          {form.section_type === "intro" && renderForm()}
        </>
      )}

      {tab === "final_cta" && (
        <>
          {pageData.final_cta && (
            <div className="mb-4 p-4 border rounded">
              <h3>{pageData.final_cta.title}</h3>
              <p>{pageData.final_cta.subtitle}</p>
              {pageData.final_cta.image && (
                <img
                  src={pageData.final_cta.image}
                  className="mt-2 w-64 rounded"
                  alt="cta"
                />
              )}
            </div>
          )}
          <button
            onClick={() => resetForm("final_cta", pageData.final_cta || null)}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {pageData.final_cta ? "Edit Final CTA" : "Add Final CTA"}
          </button>
          {form.section_type === "final_cta" && renderForm()}
        </>
      )}

      {tab === "services" &&
        renderListSection("service", pageData.services)}

      {tab === "why_choose" &&
        renderListSection("why_choose", pageData.why_choose)}

      {tab === "process" &&
        renderListSection("process", pageData.process)}

      {tab === "testimonials" &&
        renderListSection("testimonial", pageData.testimonials)}
    </div>
  );
}
